<template>
  <div class="trades">
    <div class="tradeCount">
      <div class="tradewrap">
        <h4>Trades</h4>
        <div class="trade">
          <p>Bought</p>
          <h2 class="green">{{count.buyCount}}</h2>
        </div>
        <div class="trade">
          <p>Sold</p>
          <h2 class="blue">{{count.sellCount}}</h2>
        </div>
      </div>
    </div>
    <div class="tradeCount">
      <div class="tradewrap">
        <h4>Quantity</h4>
        <div class="trade">
          <p>Bought</p>
          <h2 class="green">{{count.buyQty}}</h2>
        </div>
        <div class="trade">
          <p>Sold</p>
          <h2 class="blue">{{count.sellQty}}</h2>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import this.$http from "this.$http";
import config from "@/config";
export default {
  props: ["fromdate", "todate"],
  watch: {
    $props: {
      handler: function() {
        this.getTradeCount();
      },
      deep: true
    }
  },
  data() {
    return {
      accessToken: null,
      count: {}
    };
  },
  methods: {
    getTradeCount() {
      const auth = { headers: { authorization: this.accessToken } };
      this.$http
        .get(
          config.baseUrl +
            "/report/trade-count?fromDate=" +
            this.fromdate +
            "&toDate=" +
            this.todate,
          auth
        )
        .then(result => {
          this.count = result.data.data;
          console.log(this.count)
        });
    }
  },
  mounted() {
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.accessToken = result;
        this.getTradeCount();
      }
    });
  }
};
</script>